import ArtifactService from "../api/artifact"
import ArchiveService from "../api/archive"
import SearchService from "../api/search"

export const state = () => ({
    list: [],
    list_results: {},
    traversal_list: [],
    list_loaded: false,
    list_loading: false,
    counts_loaded: false,
    current_detail_id: '',
    next_detail_id: '',
    prev_detail_id: '',
    all_count: 0,
    archive_count: 0,
    artifact_count: 0,
    view: 'grid',
    type: 'artifact',
    sort_by: 'title,asc',
    printable_query: [],
    printable_date: null,
})

export const actions = {
    async view({commit}, params) {
        commit('setView', params)
    },
    async type({commit}, params) {
        commit('setType', params)
    },
    async list({commit,dispatch}, params) {
        commit('setList', params)
        dispatch('traversal_list', params)
        dispatch('loading', false)
    },
    async traversal_list({commit}, list) {
        if (!list.results || list.results.length == 0) return;
        let idList = list.results.map(i => {
            return {
                id: i.id, 
                type: i.type
            }
        });
        commit('setTraversalList', idList)
    },
    async counts_loaded({commit, params}) {
        commit('setCountsLoaded', params)
    },
    async counts({commit}, p) {
        let params = p.params;
        params.page = 1;
        let qArray = p.q;

        await ArtifactService.count(params.locale, qArray, params.sort, params.order, params.page, params.size)
            .then((response) => {
                commit('setArtifactCount', response.data.count)
                commit('setCountsLoaded', true)
            })
            .catch((error) => {
                commit('setCountsLoaded', true)
                commit('setArtifactCount', 0)
                console.log(`Collections API Error => ${error}`)
            })
            
        await ArchiveService.count(params.locale, qArray, params.sort, params.order, params.page, params.size)
            .then((response) => {
                commit('setArchiveCount', response.data.count)
                commit('setCountsLoaded', true)  
            })
            .catch((error) => {
                commit('setCountsLoaded', true)
                commit('setArchiveCount', 0)
                console.log(`Collections API Error => ${error}`)
            })
            
        await SearchService.count(params.locale, qArray, params.sort, params.order, params.page, params.size)
            .then((response) => {
                commit('setAllCount', response.data.count)
                commit('setCountsLoaded', true)
            })
            .catch((error) => {
                commit('setCountsLoaded', true)
                commit('setAllCount', 0)
                console.log(`Collections API Error => ${error}`)
            })
    },
    async sort_by ({commit}, params) {
        commit('setSortBy', params);
    },
    async clear ({commit, dispatch}) {
        commit('setList', [])
        dispatch('search/reset', null, {root: true})
    },
    async loading({commit}, params) {
        commit('setListLoading', params)
    },
    async printable_query({commit}, params) {
        let terms = params.map(term => {
            let termObj = {};
            termObj.searching = term[0];
            termObj.term = term[2];
            termObj.boolean = term[3] || null;
            return termObj;
        })
        commit('setPrintableQuery', terms)
    },
    async printable_date({commit}, params) {
        commit('setPrintableDate', params)
    }
}

export const mutations = {
    resetSearch(state) {
        state.list_results = state.list
    },
    setItem(state, item) {
        state.item = item
        state.item_loading = false
    },
    setView(state, data) {
        state.view = data
    },
    setType(state, data) {
        state.type = data
    },
    setArchiveCount(state, count) {
        state.archive_count = count
    },
    setArtifactCount(state, count) {
        state.artifact_count = count
    },
    setAllCount(state, count) {
        state.all_count = count
    },
    setList(state, data) {
        state.list = data
        state.list_results = data
        state.list_loaded = true
        state.list_loading = false
    },
    setListLoading(state, loading) {
        state.list_loading = loading
    },
    setSearchResults(state, results) {
        state.list_results = results
    },
    setTraversalList(state, list) {
        state.traversal_list = list
    },
    setSortBy(state, params) {
        state.sort_by = params
    },
    setCountsLoaded(state,params) {
        state.counts_loaded = params
    },
    setPrintableQuery(state,params) {
        state.printable_query = params
    },
    setPrintableDate(state,params) {
        state.printable_date = params
    }
}

export const getters = {
    json_ld() {
        return {
            "@context": "http://schema.org",
            "@type": "WebSite",
            name: "",
            description: "",
            url: ""
        }
    },
    item(state) {
        return state.item
    },
    view(state) {
        return state.view
    },
    type(state) {
        return state.type
    },
    item_loading(state) {
        return state.item_loading
    },
    list_results(state) {
        return state.list_results
    },
    list_loading(state) {
        return state.list_loading
    },
    list_loaded(state) {
        return state.list_loaded
    },
    current_page(state) {
        return state.current_page
    },
    archive_count(state) {
        return state.archive_count
    },
    artifact_count(state) {
        return state.artifact_count
    },
    all_count(state) {
        return state.all_count
    },
    traversal_list(state) {
        return state.traversal_list
    },
    sort_by(state) {
        return state.sort_by
    },
    counts_loaded(state) {
        return state.counts_loaded
    },
    printable_query(state) {
        return state.printable_query
    },
    printable_date(state) {
        return state.printable_date
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
